module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('dash-header', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.name) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.name))])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('dash-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Home\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f05fad1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 1878
// module chunks = 1